import apiClient from './apiClient';

export interface DashboardMetricValues {
  [key: string]: number | string;
}

export interface DashboardMetricItem {
  current_values: DashboardMetricValues;
  executed_at: string;
}

export interface DashboardMetricsResponse {
  [key: string]: DashboardMetricItem;
}

/**
 * ダッシュボードメトリクスを取得する
 * @returns Promise<DashboardMetricsResponse> - メトリクスデータ
 */
export const fetchDashboardMetrics = async(): Promise<DashboardMetricsResponse> => {
  const response = await apiClient.get<DashboardMetricsResponse>('/dashboard/metrics/');
  return response.data;
};
/**
 * 特定のダッシュボードメトリクスを更新する (ADMIN権限が必要)
 * @param metricKey 更新するメトリクスのキー
 * @returns Promise<DashboardMetricsResponse> - 更新後のメトリクスデータ
 */
export const updateDashboardMetric = async(metricKey: string): Promise<DashboardMetricsResponse> => {
  const response = await apiClient.put<DashboardMetricsResponse>(`/dashboard/metrics/${metricKey}/`);
  return response.data;
};
/**
 * ダッシュボードの基本情報を取得する
 * @returns 古い形式のダッシュボードデータ (仮の実装)
 */
export const fetchDashboardData = async() => {
  const response = await apiClient.get('/dashboard/');
  return response.data;
};
